import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import ProductList from "./lists/productList";
import ProductForm from "./forms/productForm";
import ModalEditor from "./ModalEditor";
import BoxEditor from "./BoxEditor";
import ProductionEditor from "./ProductionEditor";
import Button from "../form/Button";
import Modal from "../layout/Modal";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import Select from "../form/Select";
import {deleteComponent, getComponentConfig, saveComponent} from "../../utils/components";
import AuthorEditor from "./authorEditor";
import Icon from "../form/Icon";
import ComponentConfig from "../form/ComponentConfig";
import isEqual from "lodash-es/isEqual";
import {ProductSelect} from "../../utils/formatters";
import Tabs from "../layout/Tabs";
import TabContent from "../layout/TabContent";
import {sendRequest} from "../../utils/request";
import CheckBox from "../form/CheckBox";
import {isTrue} from "../../utils/other";
import ContentLoader from "../layout/ContentLoader";
import ArticleEditor from "./ArticleEditor";

class SortimentType extends React.Component {

    state = {
        sortiments: []
    }

    componentDidMount() {
        this.loadSortiments();
    }

    loadSortiments = () => {
        this.sortiments = sendRequest({
            option: "componentlist",
            component: "Sortiment",
            order: {field: "name", direction: "ASC"},
            itemsperpage: 0
        });
        this.sortiments.then((response) => {
            this.setState({
                isLoading: false,
                sortiments: response.items
            });
        });
    }

    render() {
        const all = (this.props.value || []).length + "" === "" + this.props.totalRecords && this.props.totalRecords + "" === "" + this.state.sortiments.length;
        return (
            <Box
                theme="default"
                header="Szortimentek"
                actions={<CheckBox
                    checked={all}
                    label="Összes"
                    disabled={this.props.loading || this.props.disabled}
                    saveChanges={() => {
                        if (!isTrue(all)) {
                            this.props.selectorgrid.addNewRows([...this.state.sortiments.filter((sortiment) => !(this.props.value || []).find((s) => s.id + "" === "" + sortiment.id))]);
                        } else {
                            this.props.selectorgrid.onItemsRemove([...this.state.sortiments]);
                        }
                    }}
                />}
            >
                {this.props.loading ? <ContentLoader/> : <div className="row">
                    {this.state.sortiments.map((sortiment, idx) => {
                        const checked = !!(this.props.value || []).find((s) => s.id + "" === "" + sortiment.id);
                        return <div className="col-md-2 col-lg-2 col-xs-6" key={idx}><div className="form-group"><CheckBox
                            name="optional"
                            type="bool"
                            value="1"
                            label={sortiment.name}
                            checked={checked}
                            disabled={this.props.loading || this.props.disabled}
                            saveChanges={(field, value) => {
                                if (isTrue(value)) {
                                    this.props.selectorgrid.addNewRows([sortiment]);
                                } else {
                                    this.props.selectorgrid.onItemRemove(sortiment);
                                }
                            }}
                        /></div></div>;
                    })}
                </div>}
            </Box>
        );
    }
}

class ProductChooser extends React.Component {

    show = () => {
        this.modal && this.modal.show();
    }

    hide = () => {
        this.modal && this.modal.hide();
    }

    render() {
        return (
            <Modal
                ref={(el) => this.modal = el}
                type="default"
                state={this.props.state}
                header="Új termék vagy kiadás?"
                buttons={[
                    {
                        text: 'Új kiadás',
                        onClick: async () => {
                            let values = JSON.parse(JSON.stringify({...this.props.newProto, newProtoType: true}));
                            if (this.props.newProduct) {
                                values = {...values, ...this.props.newProduct};
                            }
                            await this.props.setFormValues(values);
                            await this.props.setInitialValues({});
                            this.props.setState({newProduct: null});
                            this.modal && this.modal.hide();
                        }
                    },
                    {
                        text: 'Új termék',
                        onClick: async () => {
                            await this.props.pristineForm();
                            if (this.props.newProduct) {
                                await this.props.setFormValues({...this.props.values, ...this.props.newProduct});
                                await this.props.setInitialValues({});
                            }
                            this.props.setState({newProduct: null});
                            this.modal && this.modal.hide();
                        }
                    },
                    {
                        text: 'Mégse',
                        onClose: true,
                        onClick: () => {
                            this.modal && this.modal.hide();
                        }
                    }
                ]}
            />
        );
    }
}

class NewProductChooser extends React.Component {
    render() {
        return (
            <Modal
                ref={(el) => this.modal = el}
                state={this.props.state}
                type="default"
                header="Új termék vagy kiadás?"
                onClose={async () => {
                    this.props.onCancelNewProduct && await this.props.onCancelNewProduct();
                }}
            >
                <div className="row">
                    <Tabs
                        className="radio-style modal-tabs"
                        theme="default"
                        currentTab="newProduct"
                    >
                        <TabContent tabLabel="Új termék" tabName={"newProduct"}>
                            <div className="modal-footer with-footer-custom">
                                <div className="center-block">
                                    <Button
                                        color="default"
                                        onClick={async () => {
                                            this.props.onCancelNewProduct && await this.props.onCancelNewProduct();
                                        }}
                                    >
                                        Mégse
                                    </Button>
                                    <Button
                                        color="primary"
                                        onClick={async () => {
                                            await this.props.pristineForm();
                                            if (this.props.newProduct) {
                                                const values = JSON.parse(JSON.stringify({...values, ...this.props.newProduct}));
                                                await this.props.setFormValues(values);
                                                await this.props.setInitialValues({});
                                            }
                                            this.props.setState({newProduct: null});
                                        }}
                                    >
                                        Új termék
                                    </Button>
                                </div>
                            </div>
                        </TabContent>
                        <TabContent tabLabel="Új kiadás" tabName={"newEdition"}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <Select
                                            label={false}
                                            storeType="remote"
                                            placeholder="Vonalkód vagy cím"
                                            component="product"
                                            view={this.props.view}
                                            value={Object.keys(this.props.newProto).length ? this.props.newProto : null}
                                            valueKey={this.props.componentConfig.prototypefield}
                                            optionsTemplate={ProductSelect}
                                            saveChanges={(field, value) => {
                                                this.props.setState({newProto: {...this.props.getPrototype(JSON.parse(JSON.stringify(value)), this.props.componentConfig)}});
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer with-footer-custom">
                                <div className="center-block">
                                    <Button
                                        color="default"
                                        onClick={async () => {
                                            this.props.onCancelNewProduct && await this.props.onCancelNewProduct();
                                        }}
                                    >
                                        Mégse
                                    </Button>
                                    <Button
                                        color="primary"
                                        disabled={!Object.keys(this.props.newProto).length}
                                        onClick={async () => {
                                            await this.props.pristineForm();
                                            const values = JSON.parse(JSON.stringify({...this.props.newProto, ...(this.props.newProduct || {}), newProtoType: true}));
                                            await this.props.setFormValues(values);
                                            await this.props.setInitialValues({});
                                            this.props.setState({newProto: {}});
                                            this.props.setState({newProduct: null});
                                        }}
                                    >
                                        Új kiadás
                                    </Button>
                                </div>
                            </div>
                        </TabContent>
                    </Tabs>
                </div>
            </Modal>
        );
    }
}

class ProductEditor extends React.Component {

    state = {
        newProduct: null,
        newProto: {}
    }

    getPrototype = (values, config) => {
        const newValue = {...values};
        Object.keys(config.fielddefs).map((field) => {
            if (!config.fielddefs[field].prototype && config.prototypefield !== field) {
                delete newValue[field];
            }
        });
        return newValue;
    }

    constructor(props) {
        super(props);
        this.state.newProto = this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig);
        this.state.newProduct = this.props.newProduct;
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    pristineForm = async () => {
        try {
            const value = await this.props.pristineForm();
            if (this.props.newProduct) {
                await this.promisedSetState({
                    newProduct: this.props.newProduct,
                    newProto: this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig)
                });
            }
            return value;
        } catch (e) {
            throw e;
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (
            (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[this.props.componentConfig.idfield]
            &&
            this.props.values[this.props.componentConfig.prototypefield] !== prevProps.values[this.props.componentConfig.prototypefield])
            ||
            !isEqual(this.props.newProduct, prevProps.newProduct)
        ) {
            if (JSON.stringify(this.props.newProduct) !== JSON.stringify(this.state.newProduct) || JSON.stringify(this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig)) !== JSON.stringify(this.state.newProto)) {
                this.setState({
                    newProduct: this.props.newProduct,
                    newProto: this.getPrototype(JSON.parse(JSON.stringify(this.props.values)), this.props.componentConfig)
                });
            }
        }
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    newProduct = async () => {
        if (this.props.values[this.props.componentConfig.idfield] && this.props.values[this.props.componentConfig.prototypefield]) {
            this.modal.show();
        } else {
            this.props.pristineForm();
        }
    }

    getHeader = () => {
        return this.props.values[this.props.componentConfig.idfield] && this.props.values[this.props.componentConfig.prototypefield] ? (this.props.values.newProtoType ? "Új Kiadás adatai" : this.props.values.name) : "Új Termék adatai";
    }

    getFieldProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        if (this.props.values.newProtoType && (this.props.componentConfig.fielddefs[name] || {}).prototype === "prototype") {
            props.disabled = true;
        }
        if (this.props.values.newProtoType && name + "" !== "" + this.props.componentConfig.idfield && !(this.props.componentConfig.fielddefs[name] || {}).prototype) {
            props.required = true;
        }
        if (name === "barcode" && this.props.newProduct) {
            props.disabled = true;
        }
        return props;
    }

	render() {

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Form = this.props.formType || ProductForm;

		return (
		    <Fragment>
                {this.state.newProduct ? <NewProductChooser
                    state={this.props.newProduct ? true : undefined}
                    {...this.props}
                    getPrototype={this.getPrototype}
                    newProto={this.state.newProto}
                    setState={(state,cb) => this.setState(state,cb)}
                /> : <ProductChooser
                    state={this.props.newProduct ? false : undefined}
                    ref={(modal) => this.modal = modal}
                    {...this.props}
                    getPrototype={this.getPrototype}
                    newProto={this.state.newProto}
                    setState={(state,cb) => this.setState(state,cb)}
                />}
                <List
                    {...this.props}
                    pristineForm={this.pristineForm}
                    theme="default"
                    header={"Termékek"}
                    footer={[
                        <Button
                            key="1"
                            disabled={this.props.isLoading}
                            color="default"
                            className="pull-left"
                            onClick={this.newProduct}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <ProductList
                        ref={(el) => this.list = el}
                        {...this.props}
                        pristineForm={this.pristineForm}
                    />
                </List>
                {!this.state.newProduct && <Editor
                    {...this.props}
                    pristineForm={this.pristineForm}
                    theme="default"
                    header={this.getHeader()}
                    footer={[
                        <Button
                            key="0"
                            disabled={ !this.props.dirty || this.props.isLoading }
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <Form {...this.props} getFieldProps={this.getFieldProps} pristineForm={this.pristineForm} />
                </Editor>}
                {
                    this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.sortiments
                    &&
                    <SelectorGrid
                        columns={{
                            "name": {header: 'Megnevezés', width: 2, sortable: true, filterable: true}
                        }}
                        name={"sortiments"}
                        pageSize={0}
                        listfieldlabel={"name"}
                        data={this.props.values}
                        type={SortimentType}
                        componentConfig={this.props.componentConfig}
                        {...this.props.getFieldProps("sortiments")}
                    />
                }
                {
                    this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.videos
                    &&
                    <Box
                        theme="default"
                        header="Videók"
                    >
                        <SelectorGrid
                            columns={{
                                "title": {header: 'Megnevezés', width: 2, sortable: true, filterable: true}
                            }}
                            name={"videos"}
                            listfieldlabel={"title"}
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            {...this.props.getFieldProps("videos")}
                        />
                    </Box>
                }
                {this.props.values[this.props.componentConfig.idfield] && <Box
                    theme="default"
                    header="Szerzők"
                    footer={[
                        <AuthorEditor
                            editor={ModalEditor}
                            selection={null}
                            list={(props) => {
                                return props.footer;
                            }}
                            saveForm={async (data, componentConfig, editorProps) => {
                                await saveComponent("ProductAuthor", {
                                    author_id: data.id,
                                    role: 1,
                                    product: this.props.values[this.props.componentConfig.idfield]
                                }, "create");
                                await editorProps.setFormValues({});
                                this.ProductProductAuthorList.refresh();
                            }}
                        />
                    ]}
                >
                    <SelectorGrid
                        addRow={
                            <Select
                                name="authors"
                                component="author"
                                objectValue={true}
                                valueKey={"id"}
                                labelKey="name"
                                storeType="remote"
                                placeholder="Szerző neve"
                                saveChanges={async (field, value) => {
                                    await saveComponent("ProductAuthor", {
                                        author_id: value.id,
                                        role: 1,
                                        product: this.props.values[this.props.componentConfig.idfield]
                                    }, "create");
                                    this.ProductProductAuthorList.refresh();
                                }}
                                {...this.props.getFieldProps("authors")}
                                label={false}
                            />
                        }
                        disabled={this.props.getFieldProps("authors").disabled}
                        ref={(ProductProductAuthorList) => this.ProductProductAuthorList = ProductProductAuthorList}
                        gridid={"ProductProductAuthorList"}
                        component="ProductAuthor"
                        filter={[{field: "product", value: this.props.values[this.props.componentConfig.idfield]}]}
                        columns={{
                            "name": {header: 'Név', width: 6, sortable: true, filterable: true, renderer: (value, rowData) => {
                                    return <div>
                                                <span className={"btn btn-danger btn-xs"} onClick={async (e) => {
                                                    e && e.preventDefault();
                                                    await deleteComponent("ProductAuthor", rowData);
                                                    this.ProductProductAuthorList.refresh();
                                                }}><Icon lib="fa" name="trash"/></span>
                                        <span> {value}</span>
                                    </div>
                                }},
                            "role": {header: 'Típus', width: 6, sortable: true, filterable: true, renderer: (value, rowData) => {
                                    return <ComponentConfig componentName="ProductAuthor">{(props) => <Select
                                        objectValue={false}
                                        name="role"
                                        value={value}
                                        optionname="author_role"
                                        storeType="local"
                                        saveChanges={async (field, value) => {
                                            await saveComponent("ProductAuthor", {
                                                [props.componentConfig.idfield]: rowData[props.componentConfig.idfield],
                                                role: value
                                            }, "update");
                                            this.ProductProductAuthorList.refresh();
                                        }}
                                        label={false}
                                        {...this.props.getFieldProps("role")}
                                    />}</ComponentConfig>
                                }}
                        }}
                        orderBy={{field: "name", direction: "DESC"}}
                    />
                </Box>}
                {this.props.values[this.props.componentConfig.idfield] && <Box
                    theme="default"
                    header="Cikkek"
                    footer={[
                        <ArticleEditor
                            editorContext="productArticles"
                            editor={ModalEditor}
                            selection={null}
                            list={(props) => {
                                return props.footer;
                            }}
                            saveForm={async (data, componentConfig, editorProps) => {
                                await saveComponent("ProductArticle", {
                                    article_id: data.id,
                                    position: 1,
                                    product: this.props.values.base_product_id
                                }, "create");
                                await editorProps.setFormValues({});
                                this.ProductProductArticleList.refresh();
                            }}
                        />
                    ]}
                >
                    <SelectorGrid
                        addRow={
                            <Select
                                name="articles"
                                component="article"
                                objectValue={true}
                                valueKey="id"
                                labelKey="headline"
                                storeType="remote"
                                placeholder="Cikk címe"
                                saveChanges={async (field, value) => {
                                    await saveComponent("ProductArticle", {
                                        article_id: value.id,
                                        position: 1,
                                        product: this.props.values.base_product_id
                                    }, "create");
                                    this.ProductProductArticleList.refresh();
                                }}
                                {...this.props.getFieldProps("articles")}
                                label={false}
                            />
                        }
                        disabled={this.props.getFieldProps("articles").disabled}
                        ref={(ProductProductArticleList) => this.ProductProductArticleList = ProductProductArticleList}
                        gridid={"ProductProductArticleList"}
                        component="ProductArticle"
                        filter={[{field: "product", value: this.props.values.base_product_id}]}
                        isOrderAble={true}
                        rowReOrderBy="position"
                        onRowReorder={({sort}) => {
                            sort({
                                action: "componentlist.updateSort",
                                component: "ProductArticle",
                                filter: [{field: "product", value: this.props.values.base_product_id}],
                            });
                        }}
                        columns={{
                            "headline": {header: 'Cím', width: 6, sortable: true, filterable: true, renderer: (value, rowData) => {
                                    return <div>
                                                <span className={"btn btn-danger btn-xs"} onClick={async (e) => {
                                                    e && e.preventDefault();
                                                    await deleteComponent("ProductArticle", rowData);
                                                    this.ProductProductArticleList.refresh();
                                                }}><Icon lib="fa" name="trash"/></span>
                                        <span> {value}</span>
                                    </div>
                                }},
                            "position": {
                                header: "Sorrent",
                                filterable: true,
                                sortable: true,
                                width: 2,
                            }
                        }}
                        orderBy={{field: "position", direction: "ASC"}}
                    />
                </Box>}
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <ProductionEditor
                        presets={{product_id: this.props.values[this.props.componentConfig.idfield]}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[
                            {
                                field: "product_id",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                        saveForm={async (data, componentConfig, editorProps) => {
                            await editorProps.setFormValues({});
                        }}
                    />
                }
            </Fragment>
        );
	}
}

export default createEditor({componentName: "product", WrappedComponent: ProductEditor, props: {
    view: "admin",
    componentActions: async (action, data, params, componentConfig) => {
        if (data.newProtoType) {
            action = "create";
            delete action.newProtoType;
        }
        await Promise.all(Object.keys(componentConfig.fielddefs).map(async (fieldname) => {
            if (componentConfig.fielddefs[fieldname].type === "object" && data[fieldname] instanceof Object) {
                const config = await getComponentConfig(componentConfig.fielddefs[fieldname].object);
                data[fieldname] = data[fieldname][config.idfield] || null;
            } else if (componentConfig.fielddefs[fieldname].type === "componentlist" && data[fieldname] instanceof Array) {
                const config = await getComponentConfig(componentConfig.fielddefs[fieldname].objects);
                data[fieldname] = data[fieldname].map((item) => item[config.idfield] && {[config.idfield]: item[config.idfield]}).filter((item) => !!item);
            }
        }));
        return {action,data};
    }
}});

